export type ValidationCache = { value: string; error: string | null } | null

export interface AsyncValidationOptions {
  cacheRef: React.RefObject<ValidationCache>
  versionRef: React.RefObject<number>
  callApi: (value: string) => Promise<{ data?: unknown }>
  isResponseInvalid: (response: { data?: unknown }) => boolean
  errorMessage: string
}

export async function runAsyncValidation(
  { cacheRef, versionRef, callApi, isResponseInvalid, errorMessage }: AsyncValidationOptions,
  value: string,
): Promise<void> {
  const cache = cacheRef.current
  if (cache !== null && cache.value === value) {
    if (cache.error) throw new Error(cache.error)
    return
  }

  const requestVersion = ++versionRef.current
  let response: { data?: unknown }
  try {
    response = await callApi(value)
  } catch {
    if (versionRef.current !== requestVersion) return
    // Network/server errors should not block form submission
    return
  }

  if (versionRef.current !== requestVersion) return
  if (isResponseInvalid(response)) {
    cacheRef.current = { value, error: errorMessage }
    throw new Error(errorMessage)
  }
  cacheRef.current = { value, error: null }
}
